export const ADD = '@log/add';
export const TOGGLE_EXCLUDE_BALANCE_RELATED = '@log/toggle-exclude-balance-related';
